var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { CacheClient } from "../../../../services/basics/client-caching.service";
import { transient, autoinject } from "aurelia-dependency-injection";
import { bindable } from "aurelia-framework";
import { TableMetaData } from "../../../../models/lookups/table-metadata";
import { DataType, SourceType } from "../../../../models/queries/queries.models";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { BindingEngine } from "aurelia-binding";
import { I18N } from 'aurelia-i18n';
import { LookupValueRequest } from "../../../../models/lookups/lookup.models";
import { StringUtilities } from "../../../../utilities/strings";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { CloneUtility } from "../../../../utilities/clone";
import * as Enumerable from "linq";
import { Claims } from "../../../../constants/authentication/claims";
import { UserClaimsService } from "../../../../services/authentication/user-claims.service";
import { computedFrom } from "aurelia-binding";
import { Reflection } from "../../../../utilities/reflection";
import { CacheCategory } from "../../../../constants/lookups/lookup.constants";
import { Guid } from "../../../../utilities/guid";
var ManageSelectedLookup = /** @class */ (function () {
    function ManageSelectedLookup(lookupClientService, engine, cachingService, userClaimsService, notificationClient, i18N) {
        this.lookupClientService = lookupClientService;
        this.engine = engine;
        this.cachingService = cachingService;
        this.userClaimsService = userClaimsService;
        this.notificationClient = notificationClient;
        this.i18N = i18N;
        this.tableMetaData = null;
        this.lookupValues = [];
        this.levels = [];
        this.columns = [];
        this.canAddNewValue = true;
        this.canDeleteValues = true;
        this.canEditValues = true;
        this.selectedLookupValue = null;
        this._alreadySortedAlphabetically = false;
        this.allData = [];
        this.canAddNewValue = this.userClaimsService.hasPermission(Claims.CanAddLookups);
        this.canDeleteValues = this.userClaimsService.hasPermission(Claims.CanDeleteLookups);
        this.canEditValues = this.userClaimsService.hasPermission(Claims.CanUpdateLookups);
    }
    Object.defineProperty(ManageSelectedLookup.prototype, "isMovable", {
        get: function () {
            return this.tableMetaData && !this.tableMetaData.sortAlphabetical;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageSelectedLookup.prototype, "maxSequenceNumber", {
        get: function () {
            return this.lookupValues && this.lookupValues.length > 0
                ? Enumerable.from(this.lookupValues.map(function (meta) { return meta.sequenceNumber ? meta.sequenceNumber : 0; })).max()
                : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageSelectedLookup.prototype, "isMovableUp", {
        get: function () {
            return this.isMovable
                && this.selectedLookupValue
                && this.selectedLookupValue.sequenceNumber > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageSelectedLookup.prototype, "isMovableDown", {
        get: function () {
            return this.isMovable
                && this.selectedLookupValue
                && this.selectedLookupValue.sequenceNumber < this.maxSequenceNumber;
        },
        enumerable: false,
        configurable: true
    });
    ManageSelectedLookup.prototype.onSortAlphabeticalChanged = function () {
        var _this = this;
        if (this.tableMetaData.sortAlphabetical) {
            if (this._alreadySortedAlphabetically)
                return;
            this.dataGridVM.selectedId = null;
            this._alreadySortedAlphabetically = true;
            this.originalSequenceNumbering = [];
            Enumerable.from(this.lookupValues).orderBy(function (x) { return x.name.toLowerCase(); }).forEach(function (lookupValue, index) {
                var sequenceNumber = CloneUtility.clone(lookupValue.sequenceNumber ? lookupValue.sequenceNumber : 0);
                _this.originalSequenceNumbering.push({ name: lookupValue.name, sequenceValue: sequenceNumber });
                lookupValue.sequenceNumber = index;
            });
            this.lookupValues = Enumerable.from(this.lookupValues).orderBy(function (x) { return x.name; }).toArray();
        }
        else {
            Enumerable.from(this.lookupValues).orderBy(function (x) { return x.sequenceNumber; }).forEach(function (lookupValue, index) {
                var orignalLookupValueItem = Enumerable.from(_this.originalSequenceNumbering).firstOrDefault(function (x) { return x.name == lookupValue.name; });
                if (orignalLookupValueItem)
                    lookupValue.sequenceNumber = orignalLookupValueItem.sequenceValue ? orignalLookupValueItem.sequenceValue : 0;
                else
                    lookupValue.sequenceNumber = index;
            });
            this._alreadySortedAlphabetically = false;
        }
        this.dataGridVM.reloadData();
    };
    ManageSelectedLookup.prototype.onSelectedLookupValue = function ($event) {
        this.selectedLookupValue = $event && $event.detail ? $event.detail.item : null;
    };
    ManageSelectedLookup.prototype.tableMetaDataChanged = function (newValue, oldValue) {
        if (!this.tableMetaData) {
            return;
        }
        this.lookupValues = [];
        this.columns = [];
        this.loadLookupData();
    };
    ManageSelectedLookup.prototype.deleteLookup = function (item) {
        var index = this.lookupValues.indexOf(item);
        this.lookupValues.splice(index, 1);
    };
    ManageSelectedLookup.prototype.add = function () {
        var e_1, _a;
        var x = {};
        try {
            for (var _b = __values(this.columns), _c = _b.next(); !_c.done; _c = _b.next()) {
                var col = _c.value;
                x[col.name] = null;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        x.id = 0;
        x.parentId = this.levels && this.levels.length > 0 ? this.levels[this.levels.length - 1].id : null;
        x.isEditable = true;
        x.sequenceNumber = this.maxSequenceNumber + 1;
        x.guid = Guid.generateGuid();
        x.isActive = true;
        x.isDefault = false;
        this.lookupValues.splice(0, 0, x);
    };
    ManageSelectedLookup.prototype.moveUp = function () {
        var _this = this;
        if (!(this.selectedLookupValue && this.selectedLookupValue.sequenceNumber > 0)) {
            return;
        }
        this.lookupValues.filter(function (meta) { return meta.sequenceNumber == _this.selectedLookupValue.sequenceNumber - 1; }).forEach(function (meta) {
            meta.sequenceNumber++;
        });
        this.selectedLookupValue.sequenceNumber--;
        this.dataGridVM.reloadData();
    };
    ManageSelectedLookup.prototype.moveDown = function () {
        var _this = this;
        if (!(this.selectedLookupValue && this.selectedLookupValue.sequenceNumber < this.maxSequenceNumber)) {
            return;
        }
        this.lookupValues.filter(function (meta) { return meta.sequenceNumber == _this.selectedLookupValue.sequenceNumber + 1; }).forEach(function (meta) {
            meta.sequenceNumber--;
        });
        this.selectedLookupValue.sequenceNumber++;
        this.dataGridVM.reloadData();
    };
    ManageSelectedLookup.prototype.loadLookupData = function () {
        var _this = this;
        this.lookupClientService.getLookupColumns(this.tableMetaData.lookupId).then(function (response) {
            _this.levels.splice(0, _this.levels.length);
            _this.allData = CloneUtility.clone(response.tableRowData);
            _this._alreadySortedAlphabetically = false;
            _this.setValues(response.tableColumnMetadatas, response.tableRowData);
        }).catch(function (ex) {
            console.error(ex);
        });
    };
    ManageSelectedLookup.prototype.setValues = function (tableColumnMetadatas, tableRowData) {
        var e_2, _a;
        var _this = this;
        //ordering of columns by sequence number in db of TableColumnMetaDatas
        this.tableColumnMetaDataItems = Enumerable.from(tableColumnMetadatas).orderBy(function (x) { return x.sequenceNumber; }).toArray();
        var array = [];
        try {
            for (var _b = __values(this.tableColumnMetaDataItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                var tableColumnItem = _c.value;
                if (tableColumnItem.isPrimaryKeyColumn || tableColumnItem.columnName.toLowerCase() == "parentid") {
                    continue;
                }
                array.push({
                    name: StringUtilities.camelize(tableColumnItem.columnName),
                    sortOrder: array.length,
                    columnOrder: array.length,
                    parameter: tableColumnItem.relatedLookupName,
                    dataType: tableColumnItem.relatedLookupId ? (tableColumnItem.isMultiDimensionalRelation ? DataType.HeiricalLookup : DataType.Lookup) : tableColumnItem.tableColumnDataTypeId,
                    title: tableColumnItem.columnDisplayName,
                    value: function (item, row, column) {
                        if (column.name == "isDefault" && item[column.name] == true) {
                            _this.lookupValues.forEach(function (x) {
                                if (x != item) {
                                    x["isDefault"] = false;
                                }
                            });
                        }
                    }
                });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (this.canEditValues) {
            array.push({
                name: "edit",
                isSortable: false,
                instancePerRow: true,
                sortOrder: array.length,
                columnOrder: array.length,
                dataType: DataType.Icon,
                title: this.i18N.tr('edit-text'),
                parameter: "edit",
                value: function (x, row) {
                    x.isEditable = !x.isEditable;
                    row.columnKeys["edit"].column.parameter = row.columnKeys["edit"].column.parameter === "edit" ? "save" : "edit";
                    row.refresh();
                }
            });
        }
        if (this.canDeleteValues) {
            array.push({
                name: "delete",
                isSortable: false,
                sortOrder: array.length,
                columnOrder: array.length,
                dataType: DataType.Icon,
                title: this.i18N.tr('delete-text'),
                parameter: "close",
                value: function (x) {
                    _this.deleteLookup(x);
                }
            });
        }
        if (this.tableMetaData.hierarchicalMaxNumberOfLevels > 1 &&
            this.tableMetaData.hierarchicalMaxNumberOfLevels > this.levels.length + 1) {
            array.push({
                name: "",
                sortOrder: array.length,
                columnOrder: array.length,
                dataType: DataType.Icon,
                title: "",
                parameter: "navigate_next",
                value: function (x) {
                    _this.levels.push(x);
                    _this.lookupValues = [];
                    _this.columns = [];
                    setTimeout(function () { _this.setValues(_this.tableColumnMetaDataItems, x.children); });
                }
            });
        }
        this.columns = array;
        tableRowData.forEach(function (x, index) {
            if (!x.sequenceNumber) {
                x.sequenceNumber = index;
            }
        });
        this.lookupValues = tableRowData;
        var sortingColumn1 = {
            name: "id",
            IsHidden: true,
            sortOrder: 0,
            columnOrder: array.length,
            dataType: DataType.Number,
            title: "",
            isAscending: true,
            isSortable: true
        };
        var sortingColumn2 = {
            name: "sequenceNumber",
            IsHidden: true,
            sortOrder: 0,
            columnOrder: array.length,
            dataType: DataType.Number,
            title: "",
            isAscending: true,
            isSortable: true
        };
        this.lookups = { source: this.lookupValues, sourceType: SourceType.Collection, columns: this.columns, initialSorting: [sortingColumn1, sortingColumn2] };
        // these need to be async
        setTimeout(function () {
            if (_this.lookupValuesUow) {
                _this.lookupValuesUow.dispose();
            }
            _this.lookupValuesUow = new UnitOfWorkObserver(_this.engine, { lookupValues: _this.lookupValues }, ["isEditable"]);
            _this.lookupValuesUow.startTracking();
        });
    };
    ManageSelectedLookup.prototype.goBack = function (x) {
        this.goBackInternal(x, CloneUtility.clone(this.allData));
        var index = this.levels.indexOf(x);
        this.levels.splice(index, this.levels.length - index);
        this.dataGridVM.reloadData("reload-from-lookups");
    };
    ManageSelectedLookup.prototype.goBackInternal = function (x, values) {
        var e_3, _a;
        var _this = this;
        try {
            for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                var value = values_1_1.value;
                if (value.id == x.id) {
                    this.lookupValues = [];
                    this.columns = [];
                    setTimeout(function () { _this.setValues(_this.tableColumnMetaDataItems, values); });
                }
                else if (value.children && value.children.length > 0) {
                    this.goBackInternal(x, x.children);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    ManageSelectedLookup.prototype.save = function () {
        var _this = this;
        this.canAddNewValue = false; // disabled the save button after clicked a save. 
        var nameColumn = Enumerable.from(this.tableColumnMetaDataItems).firstOrDefault(function (x) { return x.isNameColumn; });
        if (nameColumn && Enumerable.from(this.lookupValues).any(function (x) { return !x[StringUtilities.camelize(nameColumn.columnName)]; })) {
            this.canAddNewValue = true; //enabled the save button onces updated the value for the below to save again.
            this.notificationClient.show(this.i18N.tr('validation-error-text'), nameColumn.columnDisplayName + " " + this.i18N.tr('is-required-text') + ".", NotificationType.Error);
            return;
        }
        var request = {
            lookupId: this.tableMetaData.lookupId,
            alphabeticalSorting: this.tableMetaData.sortAlphabetical,
            persistLookupsRequest: { changes: this.lookupValuesUow.getChanges() }
        };
        this.lookupClientService.updateLookupValues(request).then(function (response) {
            _this.canAddNewValue = true; // enabled the save button onces its saved successfully.
            _this.notificationClient.show(_this.i18N.tr('successfully-saved-text') + "!", _this.i18N.tr('lookup-has-been-successfully-saved-text'), NotificationType.Success);
            _this.cachingService.getKeysByCacheCategory(CacheCategory.lookups).then(function (lookups) {
                var e_4, _a;
                try {
                    for (var lookups_1 = __values(lookups), lookups_1_1 = lookups_1.next(); !lookups_1_1.done; lookups_1_1 = lookups_1.next()) {
                        var data = lookups_1_1.value;
                        if (data.request && _this.tableMetaData.lookup && _this.tableMetaData.lookup.name && data.request.lookupValueQuery
                            && data.request.lookupValueQuery.toLowerCase() == _this.tableMetaData.lookup.name.toLowerCase()) {
                            var req = new LookupValueRequest();
                            req.lookupValueQuery = data.request.lookupValueQuery;
                            req.parameters = data.request.parameters;
                            _this.cachingService.remove(req.getCacheKey());
                            console.log("clearing cache for lookup >> " + req.lookupValueQuery);
                        }
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (lookups_1_1 && !lookups_1_1.done && (_a = lookups_1.return)) _a.call(lookups_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            });
            _this.loadLookupData();
        }).catch(function (response) {
            if (response && response.exceptionNumber == 547) {
                _this.notificationClient.show(_this.i18N.tr('warning') + "!", _this.i18N.tr('lookup-cannot-be-deleted-in-use-text') + ".", NotificationType.Warning);
            }
            else {
                _this.notificationClient.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('unknown-error-text') + ".", NotificationType.Error);
            }
        });
    };
    __decorate([
        bindable(),
        __metadata("design:type", TableMetaData)
    ], ManageSelectedLookup.prototype, "tableMetaData", void 0);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.tableMetaData; }), Reflection.getPropertyPath(function (x) { return x.tableMetaData.sortAlphabetical; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ManageSelectedLookup.prototype, "isMovable", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.tableMetaData.sortAlphabetical; }), Reflection.getPropertyPath(function (x) { return x.selectedLookupValue.sequenceNumber; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ManageSelectedLookup.prototype, "isMovableUp", null);
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x.tableMetaData.sortAlphabetical; }), Reflection.getPropertyPath(function (x) { return x.selectedLookupValue.sequenceNumber; })),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ManageSelectedLookup.prototype, "isMovableDown", null);
    ManageSelectedLookup = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [LookupClientService,
            BindingEngine,
            CacheClient,
            UserClaimsService,
            NotificationClientService,
            I18N])
    ], ManageSelectedLookup);
    return ManageSelectedLookup;
}());
export { ManageSelectedLookup };
